const constants = {
  GET_TYPES_PENDING: 'GET_TYPES_PENDING',
  GET_TYPES_SUCCESS: 'GET_TYPES_SUCCESS',
  GET_TYPES_FAILURE: 'GET_TYPES_FAILURE',
};

export default constants;
